import { AdminPage } from "./pages/AdminPage";
import { ContentPage } from "./pages/ContentPage";
import { SimulatorPage } from "./pages/SimulatorPage";

export function App() {
  const path = window.location.pathname.replace(/^\/|\/$/g, "");
  if (path === "admin") return <AdminPage />;
  if (path) return <ContentPage slug={path} />;
  return <SimulatorPage />;
}
